/* eslint-disable array-bracket-newline */
import { Chart, registerables } from 'chart.js';
import { RefObject, useEffect, useRef } from 'react';
import './styles.scss';

Chart.register(...registerables);

/**
 * @returns date
 */
const getDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getDate()} ${date
    .toLocaleString('en-GB', { month: 'long' })
    .slice(0, 3)}`;
};

/**
 * Direct swap charts.js
 */
const DSChart = ({ data }: any) => {
  const canvasRef: RefObject<HTMLCanvasElement> = useRef(null);

  useEffect(() => {
    let myChart: Chart;
    if (canvasRef.current && data.length) {
      // Charts
      const ctx = canvasRef.current.getContext('2d');
      if (ctx) {
        myChart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: data.map((i: any) => getDate(i.date)), // remove dates
            datasets: [
              {
                label: 'Prices',
                data: data.map((i: any) => i.pricea),
                borderColor: '#314CF6',
                borderWidth: 2,
                pointBorderColor: 'transparent',
                pointBackgroundColor: '#314CF6',
                fill: {
                  target: 'origin',
                },
              },
            ],
          },
          options: {
            plugins: {
              tooltip: {
                displayColors: false,
                callbacks: {
                  label: (tooltipItem) => {
                    return (tooltipItem.raw as number).toString();
                  },
                },
              },
              legend: {
                display: false,
              },
            },
            scales: {
              x: {
                grid: {
                  color: '#3A3C41',
                  drawBorder: false,
                  drawOnChartArea: false,
                },
                ticks: {
                  maxTicksLimit: 8,
                  maxRotation: 0,
                  font: {
                    size: 10,
                    weight: '600',
                    family: 'Inter',
                    lineHeight: 1.5,
                  },
                },
              },
              y: {
                beginAtZero: true,
                grid: {
                  color: '#3A3C41',
                  drawBorder: false,
                  borderDash: [3, 3],
                  drawTicks: true,
                },
                ticks: {
                  maxTicksLimit: 8,
                  font: {
                    size: 10,
                    weight: '600',
                    family: 'Inter',
                    lineHeight: 1.5,
                  },
                },
              },
            },
          },
        });
      }
    }

    return () => myChart.destroy();
  }, [data]);

  return (
    <div id='dschart'>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default DSChart;
